import { AppRoot } from './features/app-shell/public'

export default function App() {
  return <AppRoot />
}
